module.exports = __webpack_public_path__ + "img/300m.f9c3b390.png";